import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

export default {
	name: 'medicine-history',
	data: () => ({
		historyList: {
			list: []
		}
	}),
	computed: {
		...mapGetters({
			medicineHistory: 'medicineHistory',
			getLoggedUser: 'getLoggedUser'
		})
	},
	methods: {
		...mapActions([
			'cancelRejectionReasonMedicine',
			'getMedicineIsTaken',
			'setMedicineHistory',
			'setMedicinePending'
		]),
		cancelRejectionMedicine(id) {

			this.cancelRejectionReasonMedicine({
				id,
				userId: this.getLoggedUser.id,
			}).then(() => {
				EventBus.$emit('medicineListChange');
				toastr.success('Rejeição cancelada com sucesso!');
			});

		}
	},
	mounted() {

		this.historyList = this.medicineHistory;

	}
};



// WEBPACK FOOTER //
// ./sources/domains/medicine/medicine-history/index.js